import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { RiSubtractFill } from "react-icons/ri";

const Diameters = ({ onAdd }) => {
    const [diameterFields, setDiameterFields] = useState([]);

    const handleAddField = () => {
        setDiameterFields([...diameterFields, '']); // Add a new empty field
    };

    const handleFieldChange = (index, value) => {
        const newFields = [...diameterFields];
        newFields[index] = value; // Update the specific field value
        setDiameterFields(newFields);
        onAdd(newFields); // Call the onAdd prop with the updated fields
    };

    const handleRemoveField = (index) => {
        const newFields = diameterFields.filter((_, i) => i !== index); // Remove the field at the specified index
        setDiameterFields(newFields);
        onAdd(newFields); // Call the onAdd prop with the updated fields
    };

    useEffect(() => {
        onAdd(diameterFields); // Call the onAdd prop with the initial diameterFields
    }, ); // Only run once on mount

    return (
        <>
            <h1 className="title mt-4">Diameters</h1>
            <div style={{backgroundColor:"#f4f4f4",padding:"10px",borderTop:"2px solid #004aad"}}>
                <button className="btn btn-primary mb-3"
                style={{backgroundColor:"#004aad",borderColor:"#004aad"}} type="button" onClick={handleAddField}>
                    Add
                </button>
                {diameterFields.map((diameter, index) => (
                    <div className="mb-3" key={index} style={{ display: 'flex', alignItems: 'center' }}>
                        <input
                            type="text"
                            className="form-control"
                            style={{ width: '80px' }} 
                            value={diameter}
                            onChange={(e) => handleFieldChange(index, e.target.value)}
                        />
                        <button
                            className="btn btn-danger ms-2"
                            onClick={() => handleRemoveField(index)}
                            style={{ marginLeft: '10px' }}
                        >
                            <RiSubtractFill />
                        </button>
                    </div>
                ))}
            </div>
        </>
    );
};

export default Diameters;
